module.exports = __webpack_public_path__ + "static/media/handshake-icon.5d4f54fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/handshake-icon.png
// module id = 33
// module chunks = 0